import { render, staticRenderFns } from "./aufgaben-leistungen.vue?vue&type=template&id=7309c388&scoped=true"
import script from "./aufgaben-leistungen.vue?vue&type=script&lang=js"
export * from "./aufgaben-leistungen.vue?vue&type=script&lang=js"
import style0 from "./aufgaben-leistungen.vue?vue&type=style&index=0&id=7309c388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7309c388",
  null
  
)

export default component.exports